import { render, staticRenderFns } from "./AccountHolderEmployer.vue?vue&type=template&id=a011afe6&scoped=true"
import script from "./AccountHolderEmployer.vue?vue&type=script&lang=ts"
export * from "./AccountHolderEmployer.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderEmployer.vue?vue&type=style&index=0&id=a011afe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a011afe6",
  null
  
)

export default component.exports